import React, { useState, useEffect, useCallback } from 'react';
import SuperAdminLayout from '@/components/superadmin/SuperAdminLayout';
import { Card } from '@/components/ui/card';
import { ScrollText } from 'lucide-react';
import { API } from '@/utils/api';
import axios from 'axios';

const ACTION_LABELS = {
  creation: 'Création',
  changement_plan: 'Changement plan',
  changement_statut: 'Changement statut',
  paiement: 'Paiement',
  suspension: 'Suspension',
  reactivation: 'Réactivation',
  suppression: 'Suppression',
};

const ACTION_COLORS = {
  creation: 'bg-emerald-500',
  paiement: 'bg-blue-500',
  suspension: 'bg-red-500',
  reactivation: 'bg-emerald-500',
  suppression: 'bg-red-500',
  changement_plan: 'bg-amber-500',
  changement_statut: 'bg-amber-500',
};

const SuperAdminLogs = ({ auth, onLogout }) => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadLogs = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/saas/logs?limit=200`);
      setLogs(res.data);
    } catch (err) { console.error(err); } finally { setLoading(false); }
  }, []);

  useEffect(() => { loadLogs(); }, [loadLogs]);

  const formatDate = (iso) => {
    if (!iso) return '-';
    const d = new Date(iso);
    return d.toLocaleDateString('fr-CH', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
  };

  return (
    <SuperAdminLayout auth={auth} onLogout={onLogout}>
      <div className="p-6 lg:p-8 space-y-6" data-testid="superadmin-logs">
        <div>
          <h1 className="text-2xl font-bold text-white">Journal d'activité</h1>
          <p className="text-sm text-slate-400">Historique de toutes les actions sur la plateforme</p>
        </div>

        {loading ? (
          <div className="text-slate-400 text-center py-20">Chargement...</div>
        ) : logs.length === 0 ? (
          <Card className="bg-slate-900 border-slate-800 p-12 text-center">
            <ScrollText className="w-12 h-12 text-slate-600 mx-auto mb-3" />
            <p className="text-slate-400">Aucune activité enregistrée</p>
          </Card>
        ) : (
          <div className="space-y-0">
            {logs.map((log, idx) => (
              <div key={log.id} className="flex gap-4 group">
                {/* Timeline */}
                <div className="flex flex-col items-center">
                  <div className={`w-3 h-3 rounded-full shrink-0 ${ACTION_COLORS[log.action] || 'bg-slate-600'}`} />
                  {idx < logs.length - 1 && <div className="w-px flex-1 bg-slate-800 min-h-[40px]" />}
                </div>
                {/* Content */}
                <div className="pb-6 flex-1 min-w-0">
                  <div className="flex items-baseline gap-2 flex-wrap">
                    <span className="text-sm font-medium text-white">{ACTION_LABELS[log.action] || log.action}</span>
                    {log.company_name && <span className="text-sm text-indigo-400">{log.company_name}</span>}
                  </div>
                  <p className="text-sm text-slate-400 mt-0.5">{log.detail}</p>
                  <p className="text-xs text-slate-600 mt-1">{formatDate(log.created_at)}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </SuperAdminLayout>
  );
};

export default SuperAdminLogs;
